/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Toast_Cancel_PlhInputs */

const vi_sl_toast_cancel_plh = /** @type {(inputs: Sl_Toast_Cancel_PlhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy phiếu lấy hàng`)
};

/**

* @param {Sl_Toast_Cancel_PlhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_toast_cancel_plh = /** @type {((inputs?: Sl_Toast_Cancel_PlhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Toast_Cancel_PlhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_toast_cancel_plh(inputs)
});